var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    { staticClass: "dropdown-item cursor-pointer", on: { click: _vm.handle } },
    [_vm._v("Reply")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }